import {
  PLAN_COMPLETED_MESSAGE,
} from 'constants/messageTypes';


export default function plansShouldUpdate(messages = {}, planQualityRequirementIds) 
{
    const {
        headlineMessages = [],
        hiddenMessages = [],
        standardMessages = [],
        defaultMessages = []
      } = messages;
  
    const qualityRelevantToCurrentPlansHasChanged =  [
      ...headlineMessages,
      ...hiddenMessages,
      ...standardMessages,
    ].some(({ qualityId }) => planQualityRequirementIds.includes(qualityId));

    const planHasBeenCompleted = defaultMessages.some(({ type }) => type === PLAN_COMPLETED_MESSAGE);

    return qualityRelevantToCurrentPlansHasChanged || planHasBeenCompleted;
}